export const HoursStatusBadge = ({ offer }) => {
  const hs = offer?.hours_status;
  if (!hs || !hs.status_label) return null;

  const isUrgent = hs.minutes_until_close != null && hs.minutes_until_close <= 180;
  const isClosed = hs.is_open === false;

  if (isClosed) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-semibold bg-slate-100 text-slate-500" data-testid="hours-status-badge">
        <span className="w-1.5 h-1.5 rounded-full bg-slate-400" />
        {hs.status_label}
      </span>
    );
  }

  if (isUrgent) {
    return (
      <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-semibold bg-red-50 text-red-600" data-testid="hours-status-badge">
        <span className="w-1.5 h-1.5 rounded-full bg-red-500 animate-pulse" />
        {hs.status_label}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-1 px-2 py-0.5 rounded-md text-[10px] font-semibold bg-emerald-50 text-emerald-600" data-testid="hours-status-badge">
      <span className="w-1.5 h-1.5 rounded-full bg-emerald-500" />
      {hs.status_label}
    </span>
  );
};
